"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lock = void 0;
class Lock {
    constructor() {
        this.inUse = false;
    }
    acquire() {
        const success = !this.inUse;
        this.inUse = true;
        return success;
    }
    release() {
        const success = this.inUse;
        this.inUse = false;
        return success;
    }
}
exports.Lock = Lock;
//# sourceMappingURL=concurrency.js.map